<section>
    <div class="comming-soon-notification">
        <p>Coming soon...</p>
    </div>
    <div class="landing-block landing-page-footer" id="app-footer">
        <div class="landing-page-footer--logo" [attr.data-cy]="'footer--logo'">
            <img src="../../../../assets/images/background/Hal-logo2024.png" alt="Halliburton Logo 2023" />
        </div>
    </div>
</section>